import React, { useState } from 'react';
import Filter from '@/pages/dashboard/components/NewFilter/index';
import KeyMetricsFilter from '@/pages/dashboard/filterPageComponents/competitor/KeyMetricsFilterNew';
import moment from 'moment';
import {
  Layout,
} from "tea-component";
const { Content } = Layout;

export default (props: any) => {
  const [keyMetricsFilter, setKeyMetricsFilter] = useState(null)
  const [filterValue, setFilterValue] = useState<any>({
    date: {
      type: 'date',
      value: [moment().subtract(7, 'days'), moment()]
    }
  });
  const inputList : Array<any>= [{
    type: 'rangeDate',
    key: 'date',
    default: {
      type: 'date',
      value: [moment().subtract(7, 'days'), moment()]
    },
    componentDefault: {
      date: [moment().subtract(7, 'days'), moment()],
      week: [moment().subtract(7, 'days'), moment()],
    }
  }];

  const changeValue = (val: any) => {
    setFilterValue({
      ...filterValue,
      ...val
    });
  }

  const handleFilterSave = (filterValue: any) => {
    setKeyMetricsFilter(filterValue)
  };

  return (
    <>
      <Content >
        <Content.Header
          title='test'
        ></Content.Header>
        <Content.Body full className={'dbd-key-metrics'}>
          <Filter latestDateType={''} value={filterValue} inputList={inputList} onInit={changeValue} onConfirm={changeValue} onReset={changeValue} />
          <KeyMetricsFilter filterConfirm={handleFilterSave} filterReset={handleFilterSave} filterInit={handleFilterSave} />
        </Content.Body>
      </Content>
      {/*<FilterBase value={filterValue} inputList={inputList} />*/}
    </>
  );
}
